import { useLanguage } from '../../../../LanguageProvider';
import Services from '../../../../services/Services';
import { useToaster } from '../../../../ToasterProvider';
import './SHSpeakerCard.css'
import { CgCloseO } from 'react-icons/cg'

export default function SHSpeakerCard({ name, title, image, isAdmin, eventID, speakerID, getEventDetails, linkedin }) {
    const token = localStorage.getItem("token")
    const { toastError } = useToaster();
    const { getTranslation } = useLanguage();

    const handleCardClick = () => {
        if (!linkedin) return;
        window.open(linkedin, "_blank", "noopener,noreferrer");
    }

    const removeSpeaker = () => {
        Services.SocialHiveRemoveSpeaker(token, eventID, speakerID)
            .then((res) => {
                if (res.data.status) {
                    getEventDetails()
                } else {
                    toastError(getTranslation("somethingWentWrong"));
                }
            })
            .catch((err) => {
                console.error(err);
                toastError(getTranslation("somethingWentWrong"));
            });
    }
    return (
        <div
            className={`speaker-card-container ${linkedin ? 'clickable' : ''}`}
            role={linkedin ? "link" : "article"}
            aria-disabled={!linkedin}
            onClick={handleCardClick}
        >

            <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start', gap:'8px'}}>
                <div style={{ width: '60px', height: '60px', minWidth: '60px', minHeight: '60px', overflow: 'hidden', borderRadius: '4px', boxSizing: 'border-box' }}>
                    <img src={image} alt={name} className='speaker-avatar' />
                </div>

                <div style={{ flexDirection: 'column', display: 'flex', alignItems: 'flex-start' }}>
                    <span className='speaker-name'>
                        {name}
                    </span>
                    <span className='speaker-title'>
                        {title}
                    </span>
                </div>
            </div>

            {isAdmin === "1" &&
                <span style={{ top: -10, right: -5, position: 'absolute' }}>
                    <CgCloseO
                        onClick={(e) => { e.stopPropagation(); removeSpeaker(); }}
                        style={{
                            backgroundColor: 'var(--logo-title)',
                            cursor: "var(--pointer)",
                            minWidth: "14px",
                            minHeight: "14px",
                            width: "14px",
                            height: "14px",
                            borderRadius: '50%',
                            color: '#ccc'
                        }}
                    />
                </span>
            }
        </div>
    )
}
